export default "__VITE_ASSET__DdeYLCwz__"